<template>
  <div>
    <div class="form-group">
      <div class="form-label">
        <label
          class="control-label"
          for="artist_name_domestic">
          {{ artist.type && artist.type === 3 ? 'ボーカロイド' : 'アーティスト' }}名
          <span class="req">＊</span>
        </label>
      </div>
      <div
        class="form-item word-break">
        {{ artist.name_ja }}
      </div>
    </div>
    <div class="form-group">
      <div class="form-label">
        <label
          class="control-label"
          for="artist_name_kana">
          {{ artist.type && artist.type === 3 ? 'ボーカロイド' : 'アーティスト' }}名（カナ表記）
          <span class="req">＊</span>
        </label>
      </div>
      <div class="form-item word-break">
        {{ artist.name_kana }}
      </div>
    </div>
    <div class="form-group">
      <div class="form-label">
        <label
          class="control-label"
          for="artist_name_en">
          {{ artist.type && artist.type === 3 ? 'ボーカロイド' : 'アーティスト' }}名（アルファベット表記）
          <span class="req">＊</span>
        </label>
      </div>
      <div class="form-item word-break">
        {{ artist.name_en }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CopyrightArtistConfirm',
  props: {
    artist: {
      type: Object,
      required: true,
    },
  },
}
</script>
